import { useTranslation } from 'react-i18next'
import { FormItem, Typogaphy } from 'vnetwork-ui'
import { User } from 'lucide-react'
import { Control, Controller, useFormContext, useWatch } from 'react-hook-form'
import useAuthStore from '@/stores/useAuthStore'

interface SenderSettingsProps {
    control: Control<any>
    senderEnabled: boolean
}

const SenderSettings: React.FC<SenderSettingsProps> = ({
    control,
    senderEnabled,
}) => {
    const { t } = useTranslation()
    const { employee } = useAuthStore()
    const { setValue } = useFormContext()

    // Watch sender fields to check if empty
    const senderName = useWatch({ control, name: 'metadata.sender.name' })
    const senderPhone = useWatch({ control, name: 'metadata.sender.phone' })
    const senderPosition = useWatch({
        control,
        name: 'metadata.sender.position',
    })

    const isSenderEmpty = !senderName && !senderPhone && !senderPosition

    const handleUseMyInfo = () => {
        if (employee) {
            setValue('metadata.sender.name', employee.employee_name || '')
            setValue(
                'metadata.sender.phone',
                employee.employee_phone_number || ''
            )
            setValue('metadata.sender.position', employee.position_name || '')
        }
    }

    return (
        <div className="space-y-2 pt-4 border-t">
            <div className="flex items-center gap-2">
                <User size={16} className="text-primary" />
                <Typogaphy className="font-medium text-primary capitalize">
                    {t('mailerCampaign:sender_information')}
                </Typogaphy>
            </div>

            <div className="flex items-center gap-3">
                <Controller
                    name="sender_enabled"
                    control={control}
                    render={({ field }) => (
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={field.value}
                                onChange={(e) =>
                                    field.onChange(e.target.checked)
                                }
                                className="w-4 h-4 accent-primary"
                            />
                            <span className="text-sm">
                                {t('mailerCampaign:use_custom_sender')}
                            </span>
                        </label>
                    )}
                />
                {senderEnabled && isSenderEmpty && (
                    <span
                        className="text-sm text-primary underline cursor-pointer"
                        onClick={handleUseMyInfo}
                    >
                        {t('mailerCampaign:use_my_information')}
                    </span>
                )}
            </div>

            {senderEnabled && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-gray-50 rounded-lg">
                    <FormItem
                        control={control}
                        name="metadata.sender.name"
                        type="textfield"
                        label={t('mailerCampaign:sender_name')}
                        placeholder={t('mailerCampaign:sender_name')}
                    />
                    <FormItem
                        control={control}
                        name="metadata.sender.gender"
                        type="textfield"
                        label={t('mailerCampaign:sender_gender')}
                        placeholder="Mr. / Ms."
                    />
                    <FormItem
                        control={control}
                        name="metadata.sender.phone"
                        type="textfield"
                        label={t('mailerCampaign:sender_phone')}
                        placeholder={t('mailerCampaign:sender_phone')}
                    />
                    <FormItem
                        control={control}
                        name="metadata.sender.position"
                        type="textfield"
                        label={t('mailerCampaign:sender_position')}
                        placeholder={t('mailerCampaign:sender_position')}
                    />
                </div>
            )}
        </div>
    )
}

export default SenderSettings
